/**
 * Sentinel date used as the lower bound of an open-ended date range filter
 * (es. "da sempre" in un filtro per intervallo di date).
 */
export const DEFAULT_START_DATE = '1970-01-01';

/**
 * Sentinel date used as the upper bound of an open-ended date range filter,
 * or when a "no expiration" value is required by a field that does not
 * accept null (es. course.expirationDate).
 */
export const DEFAULT_END_DATE = '9999-12-31';
